import * as Redux from "redux";
import storage from "redux-persist/lib/storage";
import _ from "lodash";

import { DropActions } from "src/core/drops/store/drops.actions";
import * as AT from "src/core/drops/store/drops.constants";
import { IDrop } from "src/core/drops/api/drops.api";

export interface IDropsStore {
  drop: IDrop | null;
  lastSynced?: Date;
}

const initialState: IDropsStore = { drop: null };

export const dropsReducer: Redux.Reducer<IDropsStore> = (state: IDropsStore = initialState, action: DropActions): IDropsStore => {
  switch (action.type) {
    case AT.PURGE_DROPS:
      return initialState;

    case AT.SET_DROP:
      if (_.isEqual(action.drop, state.drop)) {
        return state;
      } else {
        return {
          ...state,
          lastSynced: new Date(),
          drop: action.drop
        };
      }

    default:
      return state;
  }
};

export const dropsPersistConfig = {
  key: "drops",
  storage,
  blacklist: [ "" ]
};
